export interface PillConfig {
    borderColor: string;
    color: string;
    text: string;
    miniIcon: string;
  }
  
  export interface CardConfig {
    titleColor: string;
    borderColor: string;
    bgColor: string;
    text: string;
    icon: string;
  }
  
  export interface PopupStateConfigItem {
    headerBg: string;
    pill: PillConfig;
    heading: string;
    card: CardConfig;
    mainIcon: string;
  }
  
  export const stateConfig: Record<1 | 2 | 3, PopupStateConfigItem> = {
    1: {
      headerBg: '#FFE49B',
      pill: {
        borderColor: '#F4B400',
        color: '#F4B400',
        text: 'Approaching Cutoff',
        miniIcon: 'assets/images/mini-timer-icon.svg'
      },
      heading: "Today's check-in window closes at 11.45 AM IST",
      card: {
        titleColor: '#F4B400',
        borderColor: '#ebae02',
        bgColor: '#FFFCF5',
        text: "Any active check-ins will be interrupted. You'll be able to start a fresh check-in after 12:00 PM",
        icon: 'assets/images/important-icon.svg'
      },
      mainIcon: 'assets/images/timer-icon.svg'
    },
  
    2: {
      // headerBg: '#EAF4FF',
      headerBg: '#B9D3EF',
      pill: {
        borderColor: '#2D79C8',
        color: '#1D6ABB',
        text: 'Check-Ins Paused',
        miniIcon: 'assets/images/mini-pause-icon.svg'
      },
      heading: "Check-ins are paused during the transition window",
      card: {
        titleColor: '#2D79C8',
        borderColor: '#A7CCF9',
        bgColor: '#F2F8FF',
        text: "Please wait until 12:00 PM to start a new check-in",
        icon: 'assets/images/important-icon2.svg'
      },
      mainIcon: 'assets/images/pause-icon.svg'
    },
  
    3: {
      headerBg: '#FFF3E6',
      pill: {
        borderColor: '#F7A556',
        color: '#F7A556',
        text: 'Window Crossed',
        miniIcon: 'assets/images/mini-window-crossed-icon.svg'
      },
      heading: "Your check-in has been recorded for next day, since the current day's window closed while you were submitting",
      card: {
        titleColor: '#F7A556',
        borderColor: '#F2C199',
        bgColor: '#FFF8F2',
        text: "DYNAMIC_TOMORROW_TEXT",
        icon: 'assets/images/important-icon3.svg'
      },
      mainIcon: 'assets/images/window-crossed-icon.svg'
    }
  };